export const AxisHeight = 44;
export const AxisOffset = 100;
export const NodeHeight = 66;
export const NodeOverlayHeight = NodeHeight - 2;
export const BaseLeftPadding = 10;
export const BaseLeftPaddingV2 = 16;
export const MIN_NAME_COLUMN_WIDTH = 0.15;
export const MAX_NAME_COLUMN_WIDTH = 0.65;
export const INITIAL_NAME_COLUMN_WIDTH = 0.3;
